import { Typography, useTheme } from "@mui/material";
import moment from "moment";
import React from "react";
import hexToRGB from "utils/hexToRGB";

const allmonths = moment.months();

interface IMonthBody {
    onMonthSelect: (mnth) => void;
}
export default function MonthBody(props: IMonthBody) {
    const theme = useTheme();
    const onMonthSelect = (val) => {
        props.onMonthSelect?.(val);
    };
    const monthCells = () => {
        const m: JSX.Element[] = [];
        allmonths.forEach((value) => {
            m.push(
                <td
                    onClick={() => onMonthSelect(value)}
                    key={`month-selector-${value}`}
                    style={{
                        cursor: "pointer",
                        color: theme.palette.secondary.main,
                    }}
                    onMouseOver={(e) => {
                        (e.currentTarget as HTMLElement).style.backgroundColor =
                            hexToRGB(theme.palette.secondary.main, 0.4);
                    }}
                    onMouseOut={(e) => {
                        (e.currentTarget as HTMLElement).style.backgroundColor =
                            "";
                    }}
                >
                    <span style={{ display: "block", textAlign: "center" }}>
                        {value}
                    </span>
                </td>,
            );
        });
        return m;
    };
    const monthRows = () => {
        let cells: JSX.Element[] = [];
        const rows: JSX.Element[][] = [];
        const months = monthCells();
        months.forEach((r, i) => {
            if (i % 3 !== 0 || i === 0) {
                cells.push(r);
            } else {
                rows.push(cells);
                cells = [];
                cells.push(r);
            }
        });
        rows.push(cells);
        return rows;
    };
    return (
        <table
            style={{
                width: "100%",
                margin: 0,
                padding: 0,
                borderSpacing: "1px",
                borderCollapse: "separate",
            }}
        >
            <thead>
                <tr>
                    <td colSpan={3}>
                        <Typography align="center" variant="h1" display="block">
                            Select a Month
                        </Typography>
                    </td>
                </tr>
            </thead>
            <tbody>
                {monthRows().map((d, i) => (
                    <tr key={i}>{d}</tr>
                ))}
            </tbody>
        </table>
    );
}
